import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { WbsDataType } from "@planzone/dto";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Checkbox } from "@common/checkbox";

import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

const types: WbsDataType[] = [
  "list",
  "task",
  "milestone",
  "event",
  "doneElement",
];

function DataTypeFilter({
  selectedDataTypes,
  selectDataType,
  unSelectDataType,
}: Props) {
  const { t } = useTranslation();
  const isSelected = (type: WbsDataType) =>
    !!selectedDataTypes.find((dataType) => dataType === type);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.dataTypeFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {selectedDataTypes.length > 0 ? (
              <p className={styles.selectedDataTypes}>
                {selectedDataTypes.map((type, index) => (
                  <span key={type}>
                    {t(
                      `exportReportsPage.wbsZonesReport.filters.dataType.${type}`,
                    )}
                    {index !== selectedDataTypes.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
            ) : (
              <p className={styles.placeholder}>
                {t("exportReportsPage.wbsZonesReport.filters.show")}
              </p>
            )}
            <ToggleArrow className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              {types.map((type) => (
                <div
                  key={type}
                  className={styles.item}
                  onClick={() =>
                    isSelected(type)
                      ? unSelectDataType(type)
                      : selectDataType(type)
                  }
                >
                  <Checkbox isChecked={isSelected(type)} />
                  <p className={styles.typeName}>
                    {t(
                      `exportReportsPage.wbsZonesReport.filters.dataType.${type}`,
                    )}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { DataTypeFilter };
